import React from 'react'
import { Modal, Button } from 'react-bootstrap'

/**
 * Confirmation modal
 */
class ConfirmModal extends React.Component {
  static propTypes = {
    actionText: React.PropTypes.string.isRequired,
    message: React.PropTypes.node.isRequired,
    onAction: React.PropTypes.func.isRequired,
    onCancel: React.PropTypes.func.isRequired,
    bsStyle: React.PropTypes.func
  }

  render () {
    const { message, onCancel, onAction, actionText, bsStyle = 'primary' } = this.props

    return (
      <Modal show onHide={onCancel}>
        <Modal.Body>
          <div>{message}</div>
          <p>
            <Button
              bsStyle={bsStyle}
              onClick={onAction}>
              {actionText}
            </Button>
            &nbsp;
            <Button onClick={onCancel}>
              Cancel
            </Button>
          </p>
        </Modal.Body>
      </Modal>
    )
  }
}

export default ConfirmModal



// WEBPACK FOOTER //
// ./modules/shared/components/confirmModal.js